import { formatData } from "./utils";

// export function getSubscriptions(subsList){
//     console.log("FIRED ACTION GET_SUBSCRIPTIONS", subsList)
//     return {
//         type: "GET_SUBSCRIPTIONS",
//         payload: subsList
        
//     }
// }

export function fetchSubscriptions(){
    return async function(dispatch){  
        console.log("fetchSubscriptions ACTION ----------------------------");
        
        try {           
            let response = await fetch("/subscription/list",{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                
                credentials: 'same-origin',
            })
            let res = await response.json()
            console.log(res, res.index);
            
            let subsList = []            
            if (res.content) {
                res.content.map((subs, index) => {
                    let subscription = {
                        id: subs[0],
                        name: subs[1],
                        type: subs[2],
                        mensualite: subs[3],
                        total: subs[4],
                        status: subs[5],
                        day: subs[6],
                        stocklink:subs[7],
                        needProductID: subs[8],
                        deposit: subs[9],
                        depositDay: subs[10],
                        unlockthirdParty: subs[11],
                        prepaid_kwh: subs[12],
                        kwh: subs[13],
                        currency: subs[14],
                        miniPayment: subs[15],
                        condition: subs[16],
                        dateOfApplication: subs[17],
                    }
                    // console.log({subs, subscription});
                    subsList.push(subscription)
                })
                // console.log({subsList});
                subsList = formatData(subsList)
                console.log({subsList});
                dispatch({ type: "GET_SUBSCRIPTIONS", payload: subsList })
            }
        } catch (err) {
            console.log("[ERROR] fetchSubscriptions", err);
            
        }     
    } 
}
export function deleteSubscription(sub){
    return async function(dispatch){  
        console.log("deleteSubscription ACTION ----------------------------");
        dispatch({ type: "DELETE_SUBSCRIPTION_START", payload: "" })
        try {           
            let response = await fetch("/subscription/delete",{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    subscriptionId: sub.id
                }),
                credentials: 'same-origin',
            })
            let res = await response.json()
            
            // Backend now returns an object with {success: true/false, message: "..."}
            if(res === 'ok' || (res && (res.success === true || res.message))){ // no errors, accept both formats
                // Batch dispatches to prevent store.getState() calls during reducer execution
                dispatch({
                    type: "DELETE_SUBSCRIPTION",
                    payload: sub.id
                })
                
                // Defer completion dispatch to next tick
                setTimeout(() => {
                    dispatch({ type: "DELETE_SUBSCRIPTION_FULFILLED", payload:"" })
                }, 0)
                console.log("SUBSCRIPTION deleted")
            } else {
                const errorMessage = res?.error?.message || res?.message || "Erreur lors de la suppression";
                dispatch({
                    type: "DELETE_SUBSCRIPTION_ERROR",
                    payload: errorMessage
                })
            }
            
        } catch (err) {
            console.log("[ERROR] deleteSubscription", err);
            dispatch({
                type: "DELETE_SUBSCRIPTION_ERROR",
                payload: err
            })
        }     
    } 
}

export const disableSubscription = (sub) => {
    const methodName = "disableSubscription"
    console.log("[REDUX], => ", methodName, " - ",sub)
    return async dispatch => {
            const content = JSON.stringify({subscriptionId: sub.id});
            fetch('/subscription/disable', {
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: content,
            }).then((response) => response.json()).
                then(json => {
                    console.log("[SUCCESS],", methodName, "  ")
                    //dispatch({ type: FETCH_CLIENTS_LIST,json })
                    dispatch({ type: "DELETE_SUBSCRIPTION_FULFILLED", payload:"" })
                }).catch(error => {
                    console.log("[FAILED],", methodName, "  ", error)
                    let errorMsg = "" + error
                    let errorType = "Get client list"
                    //dispatch({ type: ERROR_ACTION, errorType, errorMsg })
                    dispatch({
                        type: "DELETE_SUBSCRIPTION_ERROR",
                        payload: errorMsg
                    })
                });
    }
}

export const changeStockManagementSubscription= (sub) => {
    const methodName = "changeStockManagementSubscription"
    console.log("[REDUX], => ", methodName, " - ",sub)
    return async dispatch => {
        dispatch({ type: "CHANGE_STOCK_SUBSCRIPTION_START", payload: "" })
        const content = JSON.stringify({subscriptionId: sub.id});
        fetch('/subscription/stockManagement', {
            method:'POST',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body: content,
        }).then((response) => response.json()).
            then(json => {
                console.log("[SUCCESS],", methodName, "  ")

                dispatch({ type: "CHANGE_STOCK_SUBSCRIPTION_FULFILLED", payload:"" })
            }).catch(error => {
                console.log("[FAILED],", methodName, "  ", error)
                let errorMsg = "" + error
                // let errorType = "Change subscription stock management"

                dispatch({
                    type: "CHANGE_STOCK_SUBSCRIPTION_ERROR",
                    payload: errorMsg
                })
            });
    }
}

